import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {clearString} from '../../../utils/commonFunctions';

const createTooltip = tooltip => (
  <Tooltip className="tooltip" id={`${clearString(tooltip)}-tooltip`}>
    {tooltip}
  </Tooltip>
);

const NavFurtherAction = ({href, icon = 'question', tooltip}) => (
  <OverlayTrigger
    overlay={createTooltip(tooltip)}
    placement="top"
  >
    <Link className={`ignite-icon ${icon}`} target="_blank" to={href}/>
  </OverlayTrigger>
);

NavFurtherAction.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.string,
  tooltip: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ])
};

export default NavFurtherAction;
